import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
@Component({
  selector: 'app-mppsg-report-term2',
  templateUrl: './mppsg-report-term2.component.html',
  styleUrls: ['./mppsg-report-term2.component.css']
})
export class MppsgReportTerm2Component implements OnInit {

  TermName='';
  StudentID = '0';
  ClassID = 0;
  PrintType = '';
  SectionID = 0;
  TermID=0;
  ScoreCardTypeID = 0;
  
  constructor(private activatedRoute: ActivatedRoute, private examService: ExamService, private lookupService: LookupService, public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) {

    this.activatedRoute.queryParams.subscribe(params => {

      this.StudentID = params['StudentID'];
      this.ClassID = params['ClassID'];
      this.PrintType = params['PrintType'];
      this.SectionID = params['SectionID'];
      this.TermID = params['TermID'];
      this.ScoreCardTypeID = params['ScoreCardTypeID'];
    

      this.GetExamStudentScoreCard()
    });

  }

  StudentReport = [];
  ScoreCardModel = {
    ClassID: 0,
    StudentID: 0,
    SectionID: 0,
    ScoreCardTypeID: 0,
    TermID:0,
    
  };
  printdate = "";
  GetExamStudentScoreCard() {
    this.StudentReport = [];
    var studentList = this.StudentID.split(',');
    for (var i = 0; i < studentList.length; i++) {
      this.ScoreCardModel = {
        ClassID: this.ClassID,
        StudentID: parseInt(studentList[i]),
        SectionID: this.SectionID,
        ScoreCardTypeID: this.ScoreCardTypeID,
        TermID:0,
        
      };
      this.examService.GetExamMppsgScoreCardTerm1(JSON.stringify(this.ScoreCardModel)).subscribe((data) => {
        this.StudentReport.push(data);
        this.TermName=data.TermList[1].TermName;
        this.printdate = moment(new Date(data.StudentDetails.FromDate)).format('DD-MMM-YYYY');
        setTimeout(() => {
          window.print();
        }, 300);

      });
    }

  }

  ngOnInit() {
  }

}
